import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Assigned(props) {
    const { t } = useTranslation("translation");
    return props.isMultipleAssigned ? (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_2"
            options={props.userData}
            limitTags={5}
            value={props.userData.filter((item) => props.userName?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.userName}
            onChange={(event, newValue) => {
                props.HandleUser(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
            renderInput={(params) => <TextField id="bl_table_TextField_1" {...params} margin="normal" label={t("Assigned")} variant="outlined" size="small"  />}
            size={props.size ?? "normal"}
        />
    ) : (
        <Autocomplete
            id="bl_table_Autocomplete_2"
            onChange={(event, newValue) => {
                props.HandleUser(newValue);
            }}
            value={!props.userName || props.userName === "null" ? null : props.userName}
            defaultValue=""
            options={props.userData.map((option) => option.userName)}
            renderInput={(params) => <TextField id="bl_table_TextField_1" {...params} margin="normal" label={t("Assigned")} variant="outlined" size="small" />}
            size={props.size ?? "normal"}
        />
    );
}
